import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const CompareIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.171 18.607C8.781 18.216 8.781 17.583 9.171 17.192L11.646 14.717C11.842 14.522 12.158 14.522 12.353 14.717L14.828 17.192C15.219 17.583 15.219 18.216 14.828 18.607L12.707 20.728C12.316 21.118 11.683 21.118 11.293 20.728L9.171 18.607Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M9.171 6.786C8.781 6.395 8.781 5.762 9.171 5.372L11.293 3.25C11.683 2.86 12.316 2.86 12.707 3.25L14.828 5.372C15.219 5.762 15.219 6.395 14.828 6.786L12.353 9.261C12.158 9.456 11.842 9.456 11.646 9.261L9.171 6.786Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M3.321 12.707C2.93 12.317 2.93 11.683 3.321 11.293L5.442 9.172C5.833 8.781 6.466 8.781 6.856 9.172L9.331 11.646C9.527 11.842 9.527 12.158 9.331 12.354L6.856 14.828C6.466 15.219 5.833 15.219 5.442 14.828L3.321 12.707Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M14.669 12.354C14.473 12.158 14.473 11.842 14.669 11.646L17.143 9.172C17.534 8.781 18.167 8.781 18.558 9.172L20.679 11.293C21.07 11.683 21.07 12.317 20.679 12.707L18.558 14.828C18.167 15.219 17.534 15.219 17.143 14.828L14.669 12.354Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

CompareIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(CompareIcon);
